var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 0.47998C5.6366 0.47998 0.479004 5.63758 0.479004 12C0.478846 13.513 0.776743 15.0113 1.35568 16.4091C1.93462 17.807 2.78326 19.0772 3.85313 20.147C4.92301 21.2169 6.19316 22.0656 7.59104 22.6445C8.98893 23.2234 10.4872 23.5213 12.0002 23.5212C18.3614 23.5212 23.5202 18.3636 23.5202 12C23.5202 5.63758 18.3614 0.47998 12.0002 0.47998ZM13.0754 4.63918C14.1986 4.63918 14.5286 5.29078 14.5286 6.03598C14.5286 6.96598 13.7846 7.82638 12.5138 7.82638C11.4506 7.82638 10.9442 7.29238 10.9754 6.40798C10.9754 5.66278 11.5982 4.63918 13.0754 4.63918ZM10.1978 18.9C9.4298 18.9 8.8694 18.4332 9.4058 16.3872L10.2854 12.7572C10.4378 12.1764 10.463 11.9436 10.2854 11.9436C10.0562 11.9436 9.059 12.3444 8.471 12.7404L8.0882 12.1128C9.9542 10.554 12.0998 9.63958 13.0178 9.63958C13.7858 9.63958 13.913 10.5468 13.5302 11.9436L12.5222 15.7596C12.3434 16.434 12.4202 16.6668 12.599 16.6668C12.8294 16.6668 13.583 16.3884 14.3246 15.804L14.759 16.3872C12.9434 18.2016 10.9646 18.9 10.1978 18.9Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.40bd1e109562bbe45b405adb001df1d4.svg";
export { ForwardRef as ReactComponent };